import { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { CBOT_FALLBACK } from "./lib";

export default function CbotStrip() {
  const [cbot, setCbot] = useState(null);
  const load = useCallback(() => api.get("/granos/cbot").then((r) => setCbot(r.data)).catch(() => {}), []);
  useEffect(() => {
    load();
    const id = setInterval(load, 60000);
    return () => clearInterval(id);
  }, [load]);

  const items = cbot?.items && cbot.items.length ? cbot.items : CBOT_FALLBACK;
  const asof = cbot?.asof ? new Date(cbot.asof * 1000) : null;

  return (
    <div data-testid="granos-cbot-strip">
      <div className="grid grid-cols-3 gap-2">
        {items.map((it) => {
          const has = it.price != null;
          const up = (it.changePct || 0) >= 0;
          return (
            <div key={it.key} className="rounded-xl bg-[#0f5233] text-white px-3 py-2">
              <p className="text-[10px] text-emerald-100/80">{it.label} · CBOT</p>
              <p className="text-[15px] font-extrabold leading-tight">
                {has ? Number(it.price).toFixed(1) : "—"} <span className="text-[9px] font-medium text-emerald-100/70">¢/bu</span>
              </p>
              <p className="text-[11px] font-bold text-lime-300 leading-tight" data-testid={`cbot-usdt-${it.key}`}>
                {has && it.usd_t != null ? `US$ ${Number(it.usd_t).toFixed(2)}/t` : "—"}
              </p>
              <p className={`text-[10px] font-semibold ${has && it.changePct != null ? (up ? "text-lime-300" : "text-red-300") : "text-emerald-100/70"}`}>
                {has && it.changePct != null ? `${up ? "+" : ""}${Number(it.changePct).toFixed(2)}%` : ""}
              </p>
            </div>
          );
        })}
      </div>
      {asof && (
        <p className="mt-1 text-[10px] text-emerald-800/70" data-testid="granos-cbot-asof">
          Dato: {asof.toLocaleString("es-AR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" })} · ~15 min retraso
        </p>
      )}
    </div>
  );
}
